import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Table } from "@pentabd/ui";

import { SelectControllerVertical } from "@components";
import { RoomConferenceListTableColumn } from "./TableColumn";

import { useRoomConference } from "@hooks/inventory/roomConference/useRoomConference";
import { useMetaData } from "@hooks/inventory/roomConfiguration/useMetaData";
import { useLanguage } from "@hooks/useLanguage";

import { getConvertedOfficeAddress } from "@helpers/baseDataConvert";
import { getConvertedMetaData } from "@helpers/inventory/metaDataConvert";
import { TablePagination } from "@helpers/tablePagination";

import { RoomConferenceResponseType } from "@type/inventory/room-conference";

import { ROOM_META_DATA } from "@constants/inventory/room-meta-data";
import { useEffect } from "react";
import { useBaseData } from "@hooks/useBaseData";

const { OFFICE, ROOM, BUILDING } = ROOM_META_DATA;

export function RoomConferenceListTable() {
  const navigate = useNavigate();

  const { data: office } = useBaseData(OFFICE);
  const { data: room, handleQuery: roomHandleQuery } = useMetaData(ROOM);
  const { data: building } = useMetaData(BUILDING);

  const { t } = useTranslation();
  const { language } = useLanguage();
  const { control, setValue, register } = useForm();
  const { roomConferenceListState, handleQuery } = useRoomConference();

  const { getData } = roomConferenceListState;
  const { data, pagination } = getData || ({} as RoomConferenceResponseType);

  useEffect(() => {
    roomHandleQuery("roomTypeId", 1); // roomTypeId = 1 ,  because of conference room id 1
  }, []);

  return (
    <div className="py-12">
      <Table
        headerExtension={{
          leftComponents: [
            <div className="row pb-0 mb-0">
              <SelectControllerVertical
                label="INVENTORY_ROOM_CONFERENCE.TABLE.FILTER.OFFICE"
                name="office"
                register={{ ...register("office") }}
                options={getConvertedOfficeAddress(office, language)}
                setValue={setValue}
                selectAction={(e) => handleQuery("officeId", e)}
                control={control}
                cols={4}
                portal
                withoutLabel
              />
              <SelectControllerVertical
                label="INVENTORY_ROOM_CONFERENCE.TABLE.FILTER.BUILDING"
                name="building"
                register={{ ...register("building") }}
                options={getConvertedMetaData(building)}
                setValue={setValue}
                selectAction={(e) => handleQuery("buildingId", e)}
                control={control}
                cols={4}
                portal
                withoutLabel
              />
              <SelectControllerVertical
                label="INVENTORY_ROOM_CONFERENCE.TABLE.FILTER.ROOM"
                name="room"
                register={{ ...register("room") }}
                options={getConvertedMetaData(room)}
                setValue={setValue}
                selectAction={(e) => handleQuery("roomId", e)}
                control={control}
                cols={4}
                portal
                withoutLabel
              />
            </div>,
          ],
        }}
        columns={RoomConferenceListTableColumn(t, navigate)}
        // edit={{
        //   customIcon: <ViewButton />,
        //   onClick: (id: string | number) => {
        //     navigate(`${id}`);
        //   },
        // }}
        rows={data}
        pagination={TablePagination(pagination, handleQuery)}
      />
    </div>
  );
}
